<template>
  <div>
     <div class="mt-3 ml-2 filterContentHeader">
      <span class="mr-2">Filter by :</span>
      <vs-select
        placeholder="Select filter"
        multiple
        class="fontSizeData"
        v-model="searchHeader"
      >
        <vs-select-item
          :key="index"
          :value="item"
          :text="item"
          v-for="(item, index) in data"
        />
      </vs-select>
    </div>
    <vs-table :data="users">
      <!--    
      <template slot="thead">
        <vs-th>
        </vs-th>
        <vs-th>
          Email
        </vs-th>
        <vs-th>
          Name
        </vs-th>
        <vs-th>
          Website
        </vs-th>
        <vs-th>
          Nro
        </vs-th>
      </template> -->

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].email">
            <vs-checkbox class="mt-1" v-model="checkBox1"></vs-checkbox>
          </vs-td>
          <vs-td :data="data[indextr].email">
            {{ data[indextr].email }}
          </vs-td>

          <vs-td :data="data[indextr].id">
            Qty : {{ data[indextr].id }} available
          </vs-td>
        
        </vs-tr>
      </template>
    </vs-table>
     
  </div>
</template>

<script>
export default {
  props: {
    selectedPart: Array,
  },
  data: () => ({
    location: {
      lo: ["Area 1", "Area 2", "Area 3", "Area 4", "Area 5", "Swift - 04"],
      item: ["Area 1", "Area 2", "Area 3", "Area 4", "Area 5", "Swift - 04"],
    },
    users: [
      {
        id: 3,
        name: "Area 1",
        username: "Bret",
        email: "สายพาน - Belt-01 ",
        website: "hildegard.org",
      },
      {
        id: 3,
        name: "Area 2",
        username: "Antonette",
        email: "Oil Filter - 03L115562 ",
        website: "anastasia.net",
      },
      {
        id: 3,
        name: "Area 3",
        username: "Samantha",
        email: "งานเชื่อมสร้างเนื้อฟัน_ก๊าซ Ar ",
        website: "ramiro.info",
      },
      {
        id: 30,
        name: "Area 3",
        username: "Samantha",
        email: "Aluminium-Air Filter 10x10",
        website: "ramiro.info",
      },
      {
        id: 66,
        name: "Area 3",
        username: "Samantha",
        email: "Air Filter - SA9711",
        website: "ramiro.info",
      },
      {
        id: 47,
        name: "Area 4",
        username: "Karianne",
        email: " ก็อกน้ำ - FCT-B4-12 ",
        website: "kale.biz",
      },
      {
        id: 35,
        name: " Swift - 04",
        username: "Kamren",
        email: "หลอดไฟ - L-9W",
        website: "demarco.info",
      },
      {
        id: 26,
        name: " Swift - 04",
        username: "Leopoldo_Corkery",
        email: " น็อต - 00004",
        website: "ola.org",
      },
    ],
  }),
};
</script>

<style>
</style>